import { List, Map, Record } from "immutable";

import { SemanticCategory, TAG_TYPES } from "@seneca/tags-service-consts";

export type CategoryType = {
  id?: string;
  text?: string;
  type?: typeof TAG_TYPES.category;
  tagIds: List<string>;
  details: Map<string, string>;
  semanticCategory?: SemanticCategory;
};

export type CategoryFromServerType = CategoryType & {
  tagIds: string[];
  type: typeof TAG_TYPES.category;
  details: any;
};

export type OptionalCategoryType = Partial<CategoryType>;

const defaultCategory: CategoryType = {
  id: undefined,
  text: undefined,
  type: undefined,
  tagIds: List(),
  details: Map<string, string>(),
  semanticCategory: undefined
};

export default class Category extends Record(defaultCategory) {}
